module.exports = __webpack_public_path__ + "static/media/GillSansBoldItalic.a5476031.otf";